import Config from 'config';
import { all, call, fork, put, select } from 'redux-saga/effects';

import request from '../../../lib/request';
import waitForSession from '../../../lib/wait-for-session';

import { getDateFilter } from '../getters';
import { getUserId } from '../../session/getters';
import { requestAndPut } from '../../dashboard/actions/sagas';

import {
  ON_BETA_DASHBOARD_MOUNT_ERROR,
  ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_STARTED,
  ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_ERROR,
  ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_SUCCESS,
  ON_BETA_DASHBOARD_FETCH_BALANCES_SUCCESS
} from '../actions';

const requestBalancesActionCreator = balances => ({
  type: ON_BETA_DASHBOARD_FETCH_BALANCES_SUCCESS,
  payload: balances ? balances.account_balances : false
});

const requestAccountReportActionCreator = report => ({
  type: ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_SUCCESS,
  payload: report ? report['event-report'] : false
});

function requestBalances() {
  const options = {
    credentials: 'include'
  };

  return request(`${Config.api.base}/account_balances/totals`, options)
    .then(resp => resp.json());
}

function requestAccountReport(userId, from, to) {
  const options = {
    credentials: 'include'
  };

  return request(`${Config.api.base}/users/${userId}/event_report?from=${from}&to=${to}`, options)
    .then(resp => resp.json());
}

export function* onDashboardMount() {
  yield call(waitForSession);
  const userId = yield select(getUserId);
  const dateFilter = yield select(getDateFilter);

  try {
    if (!userId) {
      throw new Error('No user - aborting');
    }

    yield all([
      fork(requestAndPut, [requestBalances], requestBalancesActionCreator),
      fork(requestAndPut, [requestAccountReport, userId, dateFilter.from, dateFilter.to], requestAccountReportActionCreator)
    ]);
  }
  catch (e) {
    yield put({ type: ON_BETA_DASHBOARD_MOUNT_ERROR });
  }
}


export function* getAccountReportForTimeFrame() {
  yield call(waitForSession);
  const userId = yield select(getUserId);
  const dateFilter = yield select(getDateFilter);

  try {
    yield put({ type: ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_STARTED });
    yield fork(requestAndPut, [requestAccountReport, userId, dateFilter.from, dateFilter.to], requestAccountReportActionCreator);
  }
  catch (e) {
    yield put({ type: ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_ERROR });
  }
}



// WEBPACK FOOTER //
// ./src/modules/beta-dashboard/actions/sagas.js